import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { typography } from 'material-ui/styles';
import { Tabs, Tab } from 'material-ui/Tabs';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import { toastr } from 'react-redux-toastr';
import { translate } from 'react-i18next';
import moment from 'moment';

import PageBase from '../components/PageBase';
import Message from '../components/Message';
import TermsMessage from '../components/TermsMessage';
import ActionText from '../components/ActionText';
import * as messagesActions from '../redux/modules/messages';
import i18n from '../translations/i18n';

const MessageContainer = styled.div`
  margin-bottom: 30px;
`;
const SubTitle = styled.h3`
  font-size: 16px;
  font-weight: ${typography.fontWeightLight};
  padding: 20px 0;
  display: inline-block;
`;

const StyledSubmitButton = styled(RaisedButton)`
  margin-top: 10px;
`;

const PinnedBar = styled.div`
  margin-top: 10px;
  padding-left: 0 !important;
  text-align: center;
  right: 40px;
  width: 160px;
`;

const PaperStyled = styled(Paper)`
  height: 100px !important;
`;

/*
PropTypes / DefaultProps
 */
const propTypes = {
  fetchMessages: PropTypes.func,
  paketboxMessages: PropTypes.any,
  otherMessages: PropTypes.any,
  termsMessages: PropTypes.any,
  otherModifySuccess: PropTypes.any,
  paketboxModifySuccess: PropTypes.any,
  privacyPolicyMessages: PropTypes.any,
  modifyMessages: PropTypes.func,
  fetchEventActionTexts: PropTypes.func,
  modifyEventActionTexts: PropTypes.func,
  currentUser: PropTypes.any,
  eventActionText: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {};

class Messages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLang: 'DE',
      selectedGroup: 'PAKETBOX',
      paketboxMessages: [],
      otherMessages: [],
      privacyPolicyMessages: [],
      termsMessages: [],
      eventActionText: [],
      pinnedPosition: 'absolute',
      pinnedTop: 200,
    };

    this.newMessages = {
      PAKETBOX: [],
      OTHER: [],
      TERMS_AND_CONDITIONS: [],
      PRIVACY_POLICY: [],
    };
  }

  componentWillMount() {
    this.props.fetchMessages('PAKETBOX');
    this.props.fetchMessages('OTHER');
    this.props.fetchMessages('TERMS_AND_CONDITIONS');
    this.props.fetchMessages('PRIVACY_POLICY');
    this.props.fetchEventActionTexts();

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};

    if (nextProps.paketboxMessages) {
      newState.paketboxMessages = nextProps.paketboxMessages;
    }

    if (nextProps.otherMessages) {
      newState.otherMessages = nextProps.otherMessages;
    }

    if (nextProps.termsMessages) {
      newState.termsMessages = nextProps.termsMessages;
    }

    if (nextProps.privacyPolicyMessages) {
      newState.privacyPolicyMessages = nextProps.privacyPolicyMessages;
    }

    if (nextProps.eventActionText) {
      newState.eventActionText = nextProps.eventActionText;
    }

    if (nextProps.otherModifySuccess) {
      this.newMessages.OTHER = [];
    }

    if (nextProps.paketboxModifySuccess) {
      this.newMessages.PAKETBOX = [];
    }

    if (nextProps.eventActionText) {
      this.newMessages.ACTIONS = [];
    }

    this.setState(newState);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  };

  save = () => {
    if (this.newMessages.PAKETBOX.length > 0) {
      this.props.modifyMessages(this.newMessages.PAKETBOX, 'PAKETBOX');
    }

    if (this.newMessages.OTHER.length > 0) {
      this.props.modifyMessages(this.newMessages.OTHER, 'OTHER');
    }

    if (this.newMessages.TERMS_AND_CONDITIONS.length > 0) {
      this.props.modifyMessages(this.newMessages.TERMS_AND_CONDITIONS, 'TERMS_AND_CONDITIONS');
    }

    if (this.newMessages.PRIVACY_POLICY.length > 0) {
      this.props.modifyMessages(this.newMessages.PRIVACY_POLICY, 'PRIVACY_POLICY');
    }

    if (this.newMessages.ACTIONS.length > 0) {
      const eventActionTexts = this.removeDuplicates(this.newMessages.ACTIONS);
      this.props.modifyEventActionTexts(eventActionTexts);
    }

    if (
      this.newMessages.PAKETBOX.length === 0 &&
      this.newMessages.OTHER.length === 0 &&
      this.newMessages.TERMS_AND_CONDITIONS.length === 0 &&
      this.newMessages.PRIVACY_POLICY.length === 0 &&
      this.newMessages.ACTIONS.length === 0
    ) {
      toastr.warning(this.props.t('warning'), this.props.t('no_modified_messages'));
    }

    this.newMessages = {
      PAKETBOX: [],
      OTHER: [],
      TERMS_AND_CONDITIONS: [],
      PRIVACY_POLICY: [],
      ACTIONS: [],
    };
  };

  removeDuplicates = arrArg => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) === pos);

  changeMsgHandler = (modifiedMsg) => {
    if (this.newMessages.length === 0) {
      this.newMessages[this.state.selectedGroup].push(modifiedMsg);
    } else {
      let itemIndex = false;
      this.newMessages[this.state.selectedGroup].forEach((msg, index) => {
        if (
          modifiedMsg.protocol === msg.protocol &&
          modifiedMsg.lang === msg.lang &&
          modifiedMsg.type === msg.type
        ) {
          itemIndex = index;
        }
      });

      if (itemIndex !== false) {
        this.newMessages[this.state.selectedGroup][itemIndex] = modifiedMsg;
      } else {
        // Message is not in modified array, add it
        this.newMessages[this.state.selectedGroup].push(modifiedMsg);
      }
    }
  };

  changeActionTextHandler = (object) => {
    this.newMessages.ACTIONS.push(object);
  };

  changeGroup = (group) => {
    this.setState({ selectedGroup: group });
  };

  changeLanguage = (lang) => {
    this.setState({ selectedLang: lang });
  };

  handleScroll = (event) => {
    let position = 'absolute';
    let top = 200;

    if (window.pageYOffset > 150) {
      position = 'fixed';
      top = 55;
    }

    if (this.state.pinnedPosition === position) {
      // nothing changed, no need to rerender
      return;
    }

    this.setState({
      pinnedPosition: position,
      pinnedTop: top,
    });
  };

  render() {
    const shownMessages =
      this.state.selectedGroup === 'PAKETBOX'
        ? this.state.paketboxMessages
        : this.state.otherMessages;

    if (!shownMessages) {
      return <div />;
    }

    const title = (
      <span>
        {this.props.t('modify_messages')}
        <Tabs style={{ width: 1000 }} className="tabButtons" onChange={this.changeGroup}>
          <Tab value="PAKETBOX" label={this.props.t('paketbox')} />
          <Tab value="OTHER" label={this.props.t('other')} />
          <Tab value="TERMS_AND_CONDITIONS" label={this.props.t('terms_and_conditions')} />
          <Tab value="PRIVACY_POLICY" label={this.props.t('privacy_policy')} />
          <Tab value="ACTIONS" label={this.props.t('actions')} />
        </Tabs>
      </span>
    );

    const disableSave = !(this.props.currentUser && this.props.currentUser.role === 'SUPER_ADMIN');

    return (
      <PageBase title={title}>
        <div className="row">
          <div className="col-xs-10">
            {this.state.selectedGroup === 'PAKETBOX' &&
              this.state.paketboxMessages.map((message, index) => (
                <Message
                  onChange={this.changeMsgHandler}
                  lang={this.state.selectedLang}
                  key={index}
                  content={message}
                />
              ))}

            {this.state.selectedGroup === 'OTHER' &&
              this.state.otherMessages.map((message, index) => (
                <Message
                  onChange={this.changeMsgHandler}
                  lang={this.state.selectedLang}
                  key={index}
                  content={message}
                />
              ))}

            {this.state.selectedGroup === 'TERMS_AND_CONDITIONS' &&
              this.state.termsMessages.map((message, index) => (
                <TermsMessage
                  onChange={this.changeMsgHandler}
                  lang={this.state.selectedLang}
                  key={index}
                  content={message}
                />
              ))}

            {this.state.selectedGroup === 'PRIVACY_POLICY' &&
              this.state.privacyPolicyMessages.map((message, index) => (
                <TermsMessage
                  onChange={this.changeMsgHandler}
                  lang={this.state.selectedLang}
                  key={index}
                  content={message}
                />
              ))}

            {this.state.selectedGroup === 'ACTIONS' &&
              this.state.eventActionText.map((event, index) => (
                <ActionText
                  onChange={this.changeActionTextHandler}
                  lang={this.state.selectedLang}
                  key={index}
                  content={event}
                />
              ))}
          </div>

          <PinnedBar
            style={{ position: this.state.pinnedPosition, top: this.state.pinnedTop }}
            className="col-xs-2"
          >
            <PaperStyled>
              <Tabs onChange={this.changeLanguage}>
                <Tab value="DE" label="DE" />
                <Tab value="EN" label="EN" />
                <Tab value="FR" label="FR" />
                <Tab value="IT" label="IT" />
              </Tabs>

              <StyledSubmitButton
                label={this.props.t('save')}
                type="submit"
                onTouchTap={this.save}
                disabled={disableSave}
                primary
              />
            </PaperStyled>
          </PinnedBar>
        </div>
      </PageBase>
    );
  }
}

Messages.defaultProps = defaultProps;
Messages.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    paketboxMessages: state.messages.paketboxMessages,
    paketboxModifySuccess: state.messages.paketboxModifySuccess,
    termsMessages: state.messages.termsMessages,
    termsModifySuccess: state.messages.termsModifySuccess,
    privacyPolicyMessages: state.messages.privacyPolicy,
    privacyPolicyModifySuccess: state.messages.privacyPolicyModifySuccess,
    otherMessages: state.messages.otherMessages,
    otherModifySuccess: state.messages.otherModifySuccess,
    eventActionText: state.messages.eventActionText,
    accounts: state.accounts.entities,
    currentUser: state.auth.current,
  };
}

const extended = translate(['translations'], { i18n })(Messages);
export default connect(mapStateToProps, messagesActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/Messages.js